import Pagy from '../vendor/javascripts/pagy.js.erb'

// https://ddnexus.github.io/pagy/extras#javascript
window.addEventListener('turbo:load', Pagy.init)

// Keyboard shortcuts for browsing pages of lists
// ---------------------------------------------------------------------

// The arrow keys click the link to the previous or next page, so Turbo follows
// it like any other click, with the same page transition. Bound once, as the
// document stays from page to page.
document.addEventListener('keydown', (e) => {
  if (e.target.nodeName !== 'BODY' && e.target.nodeName !== 'HTML') return
  if (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey) return

  if (e.key === 'ArrowLeft') {
    document.querySelector('.pagination .previous a[href]')?.click()
  } else if (e.key === 'ArrowRight') {
    document.querySelector('.pagination .next a[href]')?.click()
  }
})
